import React from 'react';
import { range } from 'underscore';
import withOutcome from 'sportsbook-with-outcome';
import { formatPrice } from 'sportsbook-helpers';

const Outcome = withOutcome((props) => {
  if (!props.outcome || !props.outcome.id) {
    return null;
  }

  return (
    <span
      data-id={props.outcome.id}
      className={`bvs-button-multi-sport ${props.selected ? 'active' : ''}`}
      onClick={props.outcome.h ? () => {} : props.toggleBetslip}
      clickSource="in-play"
    >
      {!props.outcome.h
        && props.showOutcomeDesc
        && props.outcome.sDesc
        && [props.outcome.sDesc, <br />]}
      {!props.outcome.h ? formatPrice(props.outcome.pr) : '-'}
    </span>
  );
});

export const makeOutcome = (outcome, showOutcomeDesc) => (
  outcome
    ? <Outcome key={outcome.id} id={outcome.id} showOutcomeDesc={showOutcomeDesc} />
    : <span className="bvs-button-multi-sport">-</span>
);

export const pickOutcomesByKeys = (outcomes, keyOrder, showOutcomeDesc) => (
  keyOrder.map((key) => makeOutcome(outcomes.find((o) => o.keyDimension === key), showOutcomeDesc))
);

export const pickOutcomesByPo = (outcomes, size, showOutcomeDesc) => (
  range(1, size + 1).map((po) => makeOutcome(outcomes.find((o) => o.po === po), showOutcomeDesc))
);

export const orderOutcomesByPo = (outcomes, showOutcomeDesc) => (
  outcomes.sort((o1, o2) => o1.po - o2.po).map((o) => makeOutcome(o, showOutcomeDesc))
);
